var fitt = require('fitt'),
Messenger = require('fitt-messenger'),
Cache = require('fitt-cache'),
debug = require('debug')('fitt-datahandler'),
cluster = require('cluster');

/**
                               * Description of the structure used for the pending object for illustrative purposes
                               *
                               *  <pre>
                               pending: {
                              	 http://site.api.prod.espninfra.starwave.com/apis/v2/scoreboard/header?_ceID=4379198&lang=en&region=us&contentorigin=espn:
                              	 [
                              		function,
                              		function
                              	 ]
                               }
                               </pre>
                               **/

/**
                                    * Master/worker process functionality for interacting with an external data service, enabling an external caching mechanism,
                                    * and aggregating identical incoming requests for data from multiple workers.
                                    *
                                    * @class
                                    * @name fitt.DataHandler
                                    * @returns {Object} Public interface
                                    */

/**
                                        * Master DataHandler function that is used by the master process.
                                        */

function DataHandler() {
    var oMessenger = void 0,
    cache = new Cache(),
    pending = {};

    /**
                   * Adds an incoming request to the structure of pending requests. These are requests that cannot be resolved
                   * immediately and we must wait for result.
                   */
    function addPendingRequest(url, respond) {
        pending[url] = [respond];
    }

    /**
       * Checks the pending structure to see if we are already waiting for an identical data request. If so, it
       * returns the responderID to reference in the pending.responders structure.
       */
    function checkForSamePendingRequest(url) {
        return typeof pending[url] !== 'undefined';
    }

    /**
       * Main incoming message handler. It checks for identical requests and then initiates data retrieval.
       */
    function handleDataRequest(message, respond) {
        var messageData = message.data,
        url = messageData.url,
        cachePolicy = messageData.cache,
        httpConfig = messageData.httpConfig;

        if (checkForSamePendingRequest(url)) {
            // identical request in progress - append respond function to existing row
            pending[url].push(respond);
            debug('Identical request detected. Size of queue: ' + pending[url].length);
            return;
        }
        addPendingRequest(url, respond);
        // Retrieve data
        retrieveData(url, cachePolicy, httpConfig).
        then(function (data) {
            // Respond to all pendings
            respondToRequest(url, data);
        }).
        catch(function (err) {
            // Let the worker know there was a failure
            respondToRequest(url, null, err);
        }).
        then(function () {
            removePendingRequest(url);
        });
    }

    /**
       * Retrieves internal cache info and responds
       *
       * @param message
       * @param respond
       */
    function handleInfoRequest(message, respond) {
        var data = message && message.data,
        method = data && data.method,
        response = void 0;

        switch (method) {
            case 'getCacheInfo':
                var manifest = cache.getManifest();

                response = {
                    items: manifest,
                    size: cache.getMemSize(manifest),
                    lastPurgeAt: cache.lastPurgeAt,
                    lastPurgeDate: cache.lastPurgeDate,
                    lastPurgeItems: cache.lastPurgeItemCount,
                    lastPurgeFreed: cache.lastPurgeMemFreed,
                    count: cache.size(),
                    lastPurger: cache.lastPurger,
                    currentMaxPct: cache.currentMaxPct,
                    currentInterval: cache.currentInterval,
                    totalSuccessfulPurges: cache.totalSuccessfulPurges };

                break;}

        respond(response);
    }

    /**
       * Removes request from the pending structure
       */
    function removePendingRequest(url) {
        delete pending[url];
    }

    /**
       * Responds to all pending responders for a given request
       */
    function respondToRequest(url, data, error) {
        var responders = pending[url];
        debug('Responding to all data requesters', url, error);
        fitt.forEach(responders, function (responder) {
            responder(data, error);
        });
    }

    /**
       * Main data retrieval logic. Checks cache before requesting via HTTP.
       * Re: caching policy: Either a string/object representing caching policy or a function that will return a string/object representing policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
       */
    function retrieveData(url, cachePolicy, httpConfig) {
        // Return from cache if present and hasn't expired, revalidate via http in background
        return cache.getHttp(url, httpConfig, cachePolicy);
    }

    return {

        /**
              * Returns the local cache instance
              *
              * @returns {fitt.Cache}
              */
        getCacheInstance: function getCacheInstance() {
            return cache;
        },

        /**
            * Set the cache instance
            *
            * @param {Object} cacheInstance FITT cache instance
            * @return {Boolean} True if set successfully
            */
        setCacheInstance: function setCacheInstance(cacheInstance) {
            var ret = false;

            if (cacheInstance instanceof Cache) {
                cache = cacheInstance;
                ret = true;
            }

            return ret;
        },

        /**
            * Instantiates messenger object and adds message listeners for master
            *
            * @name fitt.DataHandler#initialize
            * @function
            * @param {String} messageNamespace Name of namespace to use for inter-process messaging
            */
        initialize: function initialize(messageNamespace) {
            oMessenger = new Messenger(messageNamespace);
            if (cluster.isMaster) {
                oMessenger.addListener('dataRequest', function (message, respond) {
                    handleDataRequest(message, respond);
                });
                oMessenger.addListener('cacheAdmin', function (message, respond) {
                    handleInfoRequest(message, respond);
                });
            }
        },

        /**
            * Sends a message to the master process with a request for data. (WORKER ONLY)
            *
            * @name fitt.DataHandler#makeRequest
            * @function
            * @param {String} url URL of data to be requested
            * @param {String|Function|Object} cachePolicy Either a string/object representing caching policy or a function that will return a string/object representing policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
            * @returns {Promise}
            */
        makeRequest: function makeRequest(url, cachePolicy, httpConfig) {
            var dataRequest = {
                url: url,
                cache: cachePolicy,
                httpConfig: httpConfig };

            debug('makeRequest called', url, cachePolicy, 'Worker ' + cluster.worker.id);
            return oMessenger.request('dataRequest', dataRequest, cluster.worker);
        } };


}

module.exports = DataHandler();


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-datahandler/datahandler.js
// module id = 789
// module chunks = 0